var React = require('react');

function ContentPlay (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Play"),React.createElement("path",{"d":"M48.1,0C21.5,0,0,21.6,0,48.1s21.6,48.1,48.1,48.1c26.6,0,48.1-21.6,48.1-48.1C96.2,21.5,74.6,0,48.1,0z\n\t M41.9,57.3V38.7L58,48L41.9,57.3z","key":1})]);
}

ContentPlay.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 96.2 96.2","style":{"enableBackground":"new 0 0 96.2 96.2"},"xmlSpace":"preserve"};

module.exports = ContentPlay;

ContentPlay.default = ContentPlay;
